import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteAuditSchedule,
  getAuditSchedule,
  upsertAuditSchedule,
  type UpsertSchedulePayload,
} from '../api/auditSchedule';

const QUERY_KEY = ['audit-schedule'] as const;

export function useAuditSchedule() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: getAuditSchedule,
    staleTime: 60_000,
  });
}

export function useUpsertAuditSchedule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpsertSchedulePayload) => upsertAuditSchedule(payload),
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY, data);
    },
  });
}

export function useDeleteAuditSchedule() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAuditSchedule,
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY, data);
    },
  });
}
